import { ResourceMetaData } from './resource-meta-data';
import { BasePluginData } from './wizard-plugin-models/base-plugin-data.js';

export class ResourceDraft {
  /**
   * User identifier associated with the resource
   */
  userId: string = '';

  /**
   * Metadata of the resource being created
   *
   * Contains descriptive information such as name, type, version, and description
   * that identifies and categorizes the resource.
   */
  metaData: ResourceMetaData = new ResourceMetaData();

  /**
   * Dynamic resource data
   */
  data: Record<string, BasePluginData> = {};
}
